<template>
  <div class="menu-list" v-if="list.parent">
    <div class="title-mod">{{list.parent.type_name}}</div>
    <div class="main am-margin-top-sm" >
      <div class="main-context">
<div class="list">
      <ul v-if="list.child.length>0">
        <li v-for="(item,index) in list.child" :key="index" :class="[ $route.params.portId.length>6&&$route.params.portId.indexOf(item.type_id)!=-1?'active':'']">
          <router-link :to="'/list/'+item.type_id">
            {{item.type_name}}
          </router-link>
        </li>
      </ul>
      <div class="no-data" v-else>暂无子栏目</div>
    </div>
      </div>
    </div>
    
  </div>
</template>

<script> 
  export default {
    props: ["list"],
  }

</script>

<style lang="scss">
  .menu-list {
    .title-mod {
      background-image: url(~@/assets/images/menuBg2.png), url(~@/assets/images/menuBg.jpg);
background-position: left bottom,center;
      background-repeat:no-repeat, repeat-x;
      height: 103px;
      border-radius: 6px;
      box-sizing: border-box;
      padding-left: 32px;
font-size: 20px;
font-weight: bold;
color: white;
padding-top: 60px;
      position: relative;
      &::before{
        content: '';
        position:absolute;
        width: 100%;
        bottom: -30px;
        left: 0;
        height: 46px;
        background-image: url(~@/assets/images/dou2.png);
        background-repeat: no-repeat;
        background-position: center;
      }
    }
    .list {
      min-height: 132px;
      padding: 30px 0;
      ul{
        padding: 0 20px;
        li{
          border-radius: 12px;
          padding: 12px;
          margin-bottom: 12px;
        background-color: lighten($color: $primary, $amount: 20%);
        a:hover{
          text-decoration: underline;
        }
        }
      }
      
    }
  }

</style>
